import { render, staticRenderFns } from "./Confidentiality.vue?vue&type=template&id=47438f84&"
import script from "./Confidentiality.vue?vue&type=script&lang=js&"
export * from "./Confidentiality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports